<template>
  <ContentWrap>
    <el-form :inline="true" :model="query" class="-mb-15px">
      <el-form-item label="昵称">
        <el-input v-model="query.userNickname" clearable class="!w-160px" />
      </el-form-item>
      <el-form-item label="等级">
        <el-select v-model="query.rankId" clearable class="!w-160px">
          <el-option v-for="r in ranks" :key="r.id" :label="r.name" :value="r.id" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button @click="getList"><Icon icon="ep:search" class="mr-5px" />搜索</el-button>
        <el-button @click="reset"><Icon icon="ep:refresh" class="mr-5px" />重置</el-button>
      </el-form-item>
    </el-form>
  </ContentWrap>
  <ContentWrap>
    <el-table v-loading="loading" :data="list" stripe>
      <el-table-column label="用户ID" prop="userId" width="100" />
      <el-table-column label="昵称" prop="userNickname" min-width="120" />
      <el-table-column label="等级" min-width="120">
        <template #default="{ row }">{{ row.rankName || '-' }}（{{ row.rankCode || '-' }}）</template>
      </el-table-column>
      <el-table-column label="一级" prop="level1Count" width="80" />
      <el-table-column label="二级" prop="level2Count" width="80" />
      <el-table-column label="累计佣金(分)" prop="selfCommission" width="120" />
      <el-table-column label="升降时间" prop="rankTime" min-width="170" />
      <el-table-column label="锁定至" prop="rankLockedUntil" min-width="170" />
      <el-table-column label="操作" width="180" fixed="right">
        <template #default="{ row }">
          <el-button link type="primary" v-hasPermi="['bosscircle:dist-rank:adjust']" @click="openAdjust(row)">
            调档
          </el-button>
          <el-button link type="warning" v-hasPermi="['bosscircle:dist-rank:adjust']" @click="onRecalc(row)">
            重算
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <Pagination
      v-model:page="query.pageNo"
      v-model:limit="query.pageSize"
      :total="total"
      @pagination="getList"
    />
  </ContentWrap>

  <el-dialog v-model="adjustVisible" title="人工调档" width="420px">
    <el-form label-width="100px">
      <el-form-item label="用户">{{ adjust.userId }} {{ adjust.userNickname }}</el-form-item>
      <el-form-item label="目标等级">
        <el-select v-model="adjust.rankId" class="!w-220px">
          <el-option v-for="r in ranks" :key="r.id" :label="`${r.name}(${r.code})`" :value="r.id" />
        </el-select>
      </el-form-item>
      <el-form-item label="锁定截止">
        <el-date-picker
          v-model="adjust.rankLockedUntil"
          type="datetime"
          value-format="YYYY-MM-DD HH:mm:ss"
          placeholder="可选，锁定期内不自动升"
        />
      </el-form-item>
      <el-form-item label="备注">
        <el-input v-model="adjust.remark" type="textarea" :rows="2" />
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button @click="adjustVisible = false">取消</el-button>
      <el-button type="primary" :loading="saving" @click="submitAdjust">确定</el-button>
    </template>
  </el-dialog>
</template>

<script setup lang="ts">
import * as Api from '@/api/business/distRank'

defineOptions({ name: 'BusinessDistRankUser' })

const message = useMessage()
const loading = ref(false)
const saving = ref(false)
const list = ref<Api.DistRankUserVO[]>([])
const ranks = ref<Api.DistRankVO[]>([])
const total = ref(0)
const query = reactive({
  pageNo: 1,
  pageSize: 10,
  userNickname: undefined as string | undefined,
  rankId: undefined as number | undefined
})
const adjustVisible = ref(false)
const adjust = reactive({
  userId: 0,
  userNickname: '',
  rankId: undefined as number | undefined,
  remark: '',
  rankLockedUntil: undefined as string | undefined
})

const getList = async () => {
  loading.value = true
  try {
    const data = await Api.getDistRankUserPage(query)
    list.value = data?.list || []
    total.value = data?.total || 0
  } finally {
    loading.value = false
  }
}

const reset = () => {
  query.pageNo = 1
  query.userNickname = undefined
  query.rankId = undefined
  getList()
}

const openAdjust = (row: Api.DistRankUserVO) => {
  adjust.userId = row.userId
  adjust.userNickname = row.userNickname || ''
  adjust.rankId = row.rankId
  adjust.remark = ''
  adjust.rankLockedUntil = undefined
  adjustVisible.value = true
}

const submitAdjust = async () => {
  if (!adjust.rankId) {
    message.warning('请选择等级')
    return
  }
  saving.value = true
  try {
    await Api.adjustDistRankUser({
      userId: adjust.userId,
      rankId: adjust.rankId,
      remark: adjust.remark,
      rankLockedUntil: adjust.rankLockedUntil
    })
    message.success('已调档')
    adjustVisible.value = false
    await getList()
  } finally {
    saving.value = false
  }
}

const onRecalc = async (row: Api.DistRankUserVO) => {
  await Api.recalcDistRankUser(row.userId)
  message.success('已触发重算')
  await getList()
}

onMounted(async () => {
  ranks.value = (await Api.getDistRankList('MEMBER')) || []
  await getList()
})
</script>
